import {override} from "mobx";
import {GameCardViewModel} from "./game-card.view-model";
import _differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export class StatusDateGameCardViewModel extends GameCardViewModel {
  @override get gameTimeAndStatusText(): String {
    const status = this.domainModel.gameTimeAndStatusText || this.statusGameDate;

    return status;
  }

  @override get gameTimeAndShortStatusText(): String {
    const status = this.domainModel.gameTimeAndShortStatusText || this.statusGameDate;

    return status;
  }

  get statusGameDate(): String {
    let gameTimeText;
    const showToday: Boolean = this.daysLeft === 0;
    const showTomorrow: Boolean = this.daysLeft === 1;

    if (showToday)
      gameTimeText = this.terms.WEB_MY_SCORES_TODAY_BUTTON
    else if (showTomorrow) {
      gameTimeText = this.terms.GAME_TIME_TOMORROW
    }
    else {
      gameTimeText = this.date;
    }

    return gameTimeText;
  }

  get daysLeft(): Number {
    const daysLeft: Number = _differenceInCalendarDays(new Date(), this.startTime);

    return daysLeft;
  }
}
